export const sampleData = [
  {
    key: '1',
    id: '1',
    name: 'Sample Entry 1',
    category: 'Category A',
    status: 'Active',
    createdDate: '2024-01-15'
  },
  {
    key: '2',
    id: '2',
    name: 'Sample Entry 2',
    category: 'Category B',
    status: 'Inactive',
    createdDate: '2024-01-14'
  }
];

export const areaTitles: { [key: string]: string } = {
  compliance: 'Compliance Data',
  documents: 'Document Management',
  configurations: 'System Configurations',
  general: 'General Data Tables'
};

export const categoryOptions = [
  { value: 'Category A', label: 'Category A' },
  { value: 'Category B', label: 'Category B' },
  { value: 'Category C', label: 'Category C' }
];

export const statusOptions = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' }
];

export const dataEntryAreas = [
  {
    id: 'compliance',
    title: 'DATA_ENTRY_COMPLIANCE',
    description: 'DATA_ENTRY_COMPLIANCE_DESC',
    path: '/library/data-entry/compliance'
  },
  {
    id: 'documents',
    title: 'DATA_ENTRY_DOCUMENTS',
    description: 'DATA_ENTRY_DOCUMENTS_DESC',
    path: '/library/data-entry/documents'
  },
  {
    id: 'configurations',
    title: 'DATA_ENTRY_CONFIGURATIONS',
    description: 'DATA_ENTRY_CONFIGURATIONS_DESC',
    path: '/library/data-entry/configurations'
  },
  {
    id: 'general',
    title: 'DATA_ENTRY_GENERAL',
    description: 'DATA_ENTRY_GENERAL_DESC',
    path: '/library/data-entry/general'
  }
];
